import { useEffect } from 'react'
import Cookie from 'js-cookie'
import { COOKIE_THEME_KEY, THEME_DOMAIN } from 'hooks/useTheme'

const useThemeCookie = () => {
  // const theme = useContext(StyledThemeContext)
  // const themeValue = theme.isDark ? 'dark' : 'light'
  const themeValue = 'dark'

  useEffect(() => {
    localStorage.setItem(COOKIE_THEME_KEY, themeValue)
  }, [])

  useEffect(() => {
    const getThemeCookie = Cookie.get(COOKIE_THEME_KEY)

    if (!getThemeCookie && getThemeCookie !== themeValue) {
      // Cookie.set(COOKIE_THEME_KEY, themeValue, { domain: THEME_DOMAIN })
      Cookie.set(COOKIE_THEME_KEY, themeValue, { domain: 'localhost', path: '/' })
      Cookie.set(COOKIE_THEME_KEY, themeValue, { domain: '127.0.0.1', path: '/' })
      Cookie.set(COOKIE_THEME_KEY, themeValue, { domain: THEME_DOMAIN, path: '/' })
    }
  }, [themeValue])
}

export default useThemeCookie
